var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 36,
    fill: "url(#pattern0)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_352_352",
    transform: "translate(0 0.138889) scale(0.0104167 0.00752315)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_352_352",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACV0lEQVR4nO3csW4TQRSF4R9EQ40RBFpaeAVEGwLUiBKJBp4HOTRIvAGIvA4UgYYUBAoKgoHCWEIuNp54du+dyf9J07m4Myfxar1HC5IkSZLOmwvRA6y5ATwB7gJ3gCvAH+AQ+AgcAG+BT1ED9uo68Ab4yfLAh9YJ8IplWKrgIXDM6Qe/vr4DDwLm7cozYEH54a/WAngx+dSd2AN+cfbD/z8E/xMKzYAjtj/81foG7Ey6g8bNqXf4q7U/6Q4aNgN+UD+AE+DmhPuo4uIGn6l9UEfA5Zqb+OcS8GiDz9Xez2lr0CYBtGQ3eoBSvQVwK3qAUr0F0OU1oCW/owco1VsAn6MHKNVbAB+iByjVWwDvowdogTdiCbykfgDzSXfQuBnwhXqHf8zyoY4K7FLv5+j7E8/ejadsF8ICeD751J3ZA75ytq8d//IruQa8ZvOH8nM6+c7PVkvZAR4D94DbwFWWPy8csrzJOgDe0eAdryRJ67JdhGuzaxrErmkgu6aB7JoGsmsayK5pMLumgZp+xBnRDa29sndNB/XWiqht9K6pAQwbvWtqAMNSXAPOs9G7pgYwbPQnbwYwbPSuqQEMs2u6gaZvxHph1zSYXdME7JomYNc0AbumCTTTNe29lmLXVJKU1tgXYbuZQexmBrKbGchuZiC7mYHsZgazmxnIR4JbqNENzd7NjF6DsrcimnsPaKnsATT3HtBS2QPwGhCsufeAlsoeQPdPqrIH0Nx7QEtlD8Bu5ga8EUvAbmYwu5kJ2M1MwG5mAnYzE2immxlt7FqK3UxJkiRJWvMXadKsUStafT8AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/Slider.43ee18cd1f649ca6c3febd844bf457bd.svg";
export { ForwardRef as ReactComponent };